<div class="card" *ngIf="display && !editing">
    <div class="card-header d-flex">
        <button class="btn mr-1" [ngClass]="tab == 'customer' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('customer')">
            <span *ngIf="receiver == 'customer'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon text-primary">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
            </span>{{ 'Standard.Customer' | translate }}</button>
        <button class="btn mr-1" [ngClass]="tab == 'invoice' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('invoice')">
            <span *ngIf="receiver == 'invoice'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon text-primary">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
            </span>{{ 'Word.Invoice' | translate }}
        </button>
        <button class="btn mr-1" [ngClass]="tab == 'delivery' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('delivery')">
            <span *ngIf="receiver == 'delivery'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon text-primary">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
            </span>{{ 'Standard.Delivery' | translate }}
        </button>
        <button class="btn" [ngClass]="tab == 'contact' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('contact')">
            <span *ngIf="receiver == 'contact'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="hero-icon text-primary">
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
            </span>{{ 'Standard.Contact' | translate }}
        </button>
    </div>
    <div class="card-header flex-between w-100 align-items-center">
        <div class="d-flex align-items-start gap-3 w-100">
            <div class="btn btn-square btn-{{ getFirstLetterUppercase(display.name) }}">{{ getFirstLetterUppercase(display.name) }}</div>
            <div class="d-flex flex-column w-100">
                <h5 class="card-title text-nowrap ellipsis m-0">{{ display.name }}</h5>
                <div class="text-muted" *ngIf="( tab == 'customer' && !!customer.cvr) || (tab == 'invoice' && customer.ean)" >
                    <span *ngIf="tab == 'customer'">{{('Company.VatNumber' | translate) | uppercase}}  {{ customer.cvr }}</span>
                    <span *ngIf="tab == 'invoice'">{{ ('Standard.EAN' | translate) | uppercase }}  {{ customer.ean }}</span>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <button class="btn btn-secondary" (click)="showOptions = !showOptions">
                <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 2C0 1.17157 0.671573 0.5 1.5 0.5C2.32843 0.5 3 1.17157 3 2C3 2.82843 2.32843 3.5 1.5 3.5C0.671573 3.5 0 2.82843 0 2Z" fill="black"/>
                    <path d="M5.5 2C5.5 1.17157 6.17157 0.5 7 0.5C7.82843 0.5 8.5 1.17157 8.5 2C8.5 2.82843 7.82843 3.5 7 3.5C6.17157 3.5 5.5 2.82843 5.5 2Z" fill="black"/>
                    <path d="M12.5 0.5C11.6716 0.5 11 1.17157 11 2C11 2.82843 11.6716 3.5 12.5 3.5C13.3284 3.5 14 2.82843 14 2C14 1.17157 13.3284 0.5 12.5 0.5Z" fill="black"/>
                </svg>                                            
            </button>
            <div class="position-absolute border p-1 bg-white" *ngIf="showOptions" style="right:0">
                <div class="dropdown-item text-normal" (click)="changeReceiver(tab)" *ngIf="receiver != tab">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>{{ 'Buttons.PrimaryContact' | translate }}
                </div>
                <div href="/" class="dropdown-item text-normal" (click)="editing = true; showOptions= false;">{{ 'Word.Edit' | translate }}</div>
                <div href="/" class="dropdown-item text-normal" (click)="switch()">{{ 'Word.Change' | translate }}</div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="d-flex gap-3 align-items-start">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
            </div>
            <div class="d-flex flex-column gap-1">
                <div>{{ display.address }}</div>
                <div>{{ display.zip }} {{ display.city }}</div>
                <a class="text-bold cursor-pointer text-decoration-none text-normal text-black" [href]="'http://maps.google.com/maps?q=' + display.address + ' ' + display.zip + ' ' + display.city" target="_blank" *ngIf="display.address || (display.zip && display.city)">{{ 'Standard.ViewInGoogleMaps' | translate }}</a>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-flex gap-3">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon-outline">
                    <path stroke-linecap="round" d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25" />
                </svg>
            </div>
            <a class="cursor-pointer text-decoration-none text-normal text-black text-bold" [href]="'mailto:' + display.email" target="_blank" *ngIf="display.email">{{ display.email }}</a>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-flex gap-3">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon-outline">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                </svg>
            </div>
            <a class="cursor-pointer text-decoration-none text-normal text-black text-bold" [href]="'tel:' + display.mobile" target="_blank" *ngIf="display.mobile">{{ display.mobile }}</a>
        </div>
    </div>
</div>

<div class="card" *ngIf="display && editing">
    <div class="card-body d-flex flex-column gap-3">
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Name' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.name">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Address' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.address">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Zipcode' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.zip">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.City' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.city">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Email' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.email">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Phone' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.phone">
        </div>
        <div class="w-100 flex-between">
            <div>{{ 'Standard.Mobile' | translate }}</div>
            <input type="text" class="form-control w-50" [(ngModel)]="display.mobile">
        </div>
    </div>
    <div class="card-footer flex-between">
        <button class="btn btn-secondary" (click)="cancelEdit()">{{ 'Buttons.Close' | translate }}</button>
        <button class="btn btn-primary" (click)="save()">{{ 'Buttons.Save' | translate }}</button>
    </div>
</div>

<div class="card" *ngIf="(tab == 'delivery' || tab == 'contact') && !display">
    <div class="card-header d-flex">
        <button class="btn mr-1" [ngClass]="tab == 'customer' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('customer');editing = false;">{{ 'Standard.Customer' | translate }}</button>
        <button class="btn mr-1" [ngClass]="tab == 'invoice' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('invoice');editing = false;">{{ 'Word.Invoice' | translate }}</button>
        <button class="btn mr-1" [ngClass]="tab == 'delivery' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('delivery');editing = false;">{{ 'Standard.Delivery' | translate }}</button>
        <button class="btn" [ngClass]="tab == 'contact' ? 'btn-secondary' : 'btn-light'" (click)="switchTab('contact');editing = false;">{{ 'Standard.Contact' | translate }}</button>
    </div>
    <div class="card-body d-flex flex-between" *ngIf="!display && !editing">
        <div class="p-1">{{ 'Standard.NoAddress' | translate }}</div>
        <div class="position-relative">
            <button class="btn btn-secondary" (click)="showExtras = !showExtras">
                <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 2C0 1.17157 0.671573 0.5 1.5 0.5C2.32843 0.5 3 1.17157 3 2C3 2.82843 2.32843 3.5 1.5 3.5C0.671573 3.5 0 2.82843 0 2Z" fill="black"/>
                    <path d="M5.5 2C5.5 1.17157 6.17157 0.5 7 0.5C7.82843 0.5 8.5 1.17157 8.5 2C8.5 2.82843 7.82843 3.5 7 3.5C6.17157 3.5 5.5 2.82843 5.5 2Z" fill="black"/>
                    <path d="M12.5 0.5C11.6716 0.5 11 1.17157 11 2C11 2.82843 11.6716 3.5 12.5 3.5C13.3284 3.5 14 2.82843 14 2C14 1.17157 13.3284 0.5 12.5 0.5Z" fill="black"/>
                </svg>                                            
            </button>
            <div class="position-absolute border p-1 bg-white" *ngIf="showExtras" style="right:0">
                <div class="dropdown-item text-normal" (click)="extraState = 'search';editing = true; showExtras = false; filterExtra();">{{ 'Standard.Search' | translate }}</div>
                <div class="dropdown-item text-normal" (click)="extraState = 'add';editing = true; showExtras = false; resetNew();">{{ 'Buttons.Add' | translate }}</div>
            </div>
        </div>
    </div>
    <div class="card-body" *ngIf="extraState == 'search' && !!editing">
        <div class="d-flex gap-3">
            <input type="text" class="form-control" [(ngModel)]="searchString" placeholder="{{ ('Standard.Search' | translate) + ' ' +( ( 'Standard.DeliveryAddress' | translate ) | lowercase )  }}" (keyup)="filterExtra()">
            <button class="btn btn-secondary" (click)="extraState = 'add'; resetNew()">{{ 'Buttons.Add' | translate }}</button>
        </div>
        <table *ngIf="tab == 'delivery'" aria-label="Delivery addresses">
            <thead>
                <th>{{ 'Standard.Name' | translate }}</th>
                <th>{{ 'Standard.Address' | translate }}</th>
            </thead>
            <tbody>
                <tr *ngFor="let d of extraAddresses | slice: 0:10" (click)="switchDelivery(d.id)">
                    <td>{{ d.name }}</td>
                    <td>{{ d.address }}</td>
                </tr>
            </tbody>
        </table>
        <table *ngIf="tab == 'contact'" aria-label="Contacts">
            <thead>
                <th>{{ 'Standard.Name' | translate }}</th>
                <th>{{ 'Standard.Address' | translate }}</th>
            </thead>
            <tbody>
                <tr *ngFor="let c of extraAddresses | slice: 0:10" (click)="switchContact(c.id)">
                    <td>{{ c.name }}</td>
                    <td>{{ c.address }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-body" *ngIf="extraState == 'add'"></div>
    <div class="card-footer flex-between">
        <button class="btn btn-secondary" (click)="editing = false;">{{ 'Buttons.Close' | translate }}</button>
    </div>
</div>